import { render, staticRenderFns } from "./BehavioralCompetencies.vue?vue&type=template&id=0b8b41bc"
import script from "./BehavioralCompetencies.vue?vue&type=script&lang=js"
export * from "./BehavioralCompetencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports